/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateEvidenceInfoRequest
 */
export interface UpdateEvidenceInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceInfoRequest
     */
    'electronicMethod'?: UpdateEvidenceInfoRequestElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceInfoRequest
     */
    'documentSize'?: UpdateEvidenceInfoRequestDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateEvidenceInfoRequest
     */
    'heightMillis'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateEvidenceInfoRequest
     */
    'widthMillis'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceInfoRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceInfoRequest
     */
    'irrelevantToLedger'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceInfoRequest
     */
    'dpiForciblyValid'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceInfoRequest
     */
    'colorGradationForciblyValid'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceInfoRequest
     */
    'uploadedByRecipient'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceInfoRequest
     */
    'uploadedFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceInfoRequest
     */
    'invoiceIssuerRegistrationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceInfoRequest
     */
    'invoiceIssuerName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceInfoRequest
     */
    'asQualified'?: boolean | null;
}

export const UpdateEvidenceInfoRequestElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type UpdateEvidenceInfoRequestElectronicMethodEnum = typeof UpdateEvidenceInfoRequestElectronicMethodEnum[keyof typeof UpdateEvidenceInfoRequestElectronicMethodEnum];
export const UpdateEvidenceInfoRequestDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type UpdateEvidenceInfoRequestDocumentSizeEnum = typeof UpdateEvidenceInfoRequestDocumentSizeEnum[keyof typeof UpdateEvidenceInfoRequestDocumentSizeEnum];


